import sessionsTranslations from './sessions.frCa.json'
import catalogsTranslations from './catalogs.frCa.json'
import categoriesTranslations from './categories.frCa.json'
import organizationsTranslations from './organizations.frCa.json'
import errorsTranslations from './errors.frCa.json'
import globalTranslations from './global.frCa.json'
import materialModelsTranslations from './materialModels.frCa.json'
import carbonModelsTranslations from './carbonModels.frCa.json'
import materialsTranslations from './materials.frCa.json'
import ordersTranslations from './orders.frCa.json'
import usersTranslations from './users.frCa.json'
import requestsTranslations from './requests.frCa.json'
import reportsTranslations from './reports.frCa.json'
import chatsTranslations from './chats.frCa.json'
import inventoryChecksTranslations from './inventoryChecks.frCa.json'

const FRCA = {
  chats: chatsTranslations,
  catalogs: catalogsTranslations,
  categories: categoriesTranslations,
  organizations: organizationsTranslations,
  errors: errorsTranslations,
  global: globalTranslations,
  materialModels: materialModelsTranslations,
  carbonModels: carbonModelsTranslations,
  materials: materialsTranslations,
  orders: ordersTranslations,
  users: usersTranslations,
  requests: requestsTranslations,
  sessions: sessionsTranslations,
  reports: reportsTranslations,
  inventoryChecks: inventoryChecksTranslations,
}

export default FRCA
